module.exports = __webpack_public_path__ + "img/mahogany-mask.a9b879dc.png";